import {
  LogoRemarkableFull,
  LogoRemarkableSymbol,
} from '@remarkable/ark-icons/logos';
import { useTheme } from 'src/utils/useTheme';

export const RemarkableLogo = ({
  color,
  colorOnDark,
  variant = 'full',
  className = '',
  width,
  height,
}: {
  color: 'white' | 'black';
  colorOnDark?: 'white' | 'black';
  variant?: 'full' | 'symbol';
  className?: string;
  width?: number;
  height?: number;
}) => {
  const { theme } = useTheme();
  const isDarkTheme = theme.includes('dark');

  const LogoComponent =
    variant === 'full' ? LogoRemarkableFull : LogoRemarkableSymbol;

  let showDarkLogo = true;

  if (color === 'black') {
    showDarkLogo = true;
  }
  if (isDarkTheme) {
    showDarkLogo = false;
  }
  if (isDarkTheme && colorOnDark) {
    showDarkLogo = colorOnDark === 'black';
  }

  const finalWidth = width || (variant === 'full' ? 145 : 20);
  const finalHeight = height || 20;

  return (
    <LogoComponent
      alt="Remarkable Logo"
      width={finalWidth}
      height={finalHeight}
      color={showDarkLogo ? 'currentColor' : 'white'}
      className={className}
    />
  );
};
